module.exports = __webpack_public_path__ + "fonts/19d313b.otf";